var defaultDto = {
    id: 0,
    userItemId: 0,
    userId: 0,
    headId: 0,
    date: new Date(),
    duration: 0,
    note: ''
};
var TimeItem = /** @class */ (function () {
    function TimeItem(dto) {
        if (dto === void 0) { dto = defaultDto; }
        this.id = dto.id;
        this.userId = dto.userId;
        this.headId = dto.headId;
        this.date = new Date(dto.date);
        this.duration = dto.duration;
        this.userItemId = dto.userItemId;
        this.note = dto.note;
    }
    return TimeItem;
}());
export { TimeItem };



//////////////////
// WEBPACK FOOTER
// ./src/models/TimeItem.ts
// module id = 189
// module chunks = 0